import styles from './index.module.less'
import { Input } from 'antd'
import Icon from '@ant-design/icons'
import { PasswordHiddenIcon, PasswordVisibleIcon } from '@/components/icons'
import { useSetState } from 'ahooks'
// import { trim } from 'lodash-es'
import classNames from 'classnames'

export default function PasswordInput(props) {
  const { onSubmit, className, onChange, ...rest } = props

  const [state, setState] = useSetState({
    passwordVisible: false,
  })
  const togglePwdVisible = () => {
    setState({
      passwordVisible: !state.passwordVisible,
    })
  }
  const handleChange = event => {
    onChange?.(event.target.value.replace?.(/\s/g, ''))
  }
  return (
    <Input
      onPressEnter={onSubmit}
      className={classNames(className, styles.formInput, styles.passwordInput)}
      placeholder={props.placeholder || '请输入密码'}
      type={state.passwordVisible ? undefined : 'password'}
      onChange={handleChange}
      autoComplete={'off'}
      {...rest}
      // iconRender={visible =>
      //   visible ? (
      //     <Icon component={PasswordVisibleIcon} />
      //   ) : (
      //     <Icon component={PasswordHiddenIcon} />
      //   )
      // }
      suffix={
        <div className={styles.suffix}>
          <div className={styles.inputIconWrap} onClick={togglePwdVisible}>
            {state.passwordVisible ? (
              <Icon component={PasswordVisibleIcon} />
            ) : (
              <Icon component={PasswordHiddenIcon} />
            )}
          </div>
        </div>
      }
    />
  )
}
